module.exports = __webpack_public_path__ + "static/media/intro.b8bf836a.mp3";